"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SpinnerErrorMessage = props => {
  var {
    error
  } = props;
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    vertical: 2,
    key: "error-message-box"
  }, /*#__PURE__*/_react.default.createElement("h1", null, "Error!"), /*#__PURE__*/_react.default.createElement("pre", null, error));
};
SpinnerErrorMessage.propTypes = {
  error: _propTypes.default.string.isRequired
};
var _default = exports.default = SpinnerErrorMessage;